<template>
  <div>
    <navigation />
    <section class="contact">
      <div class="contact--top">
      <img src="./../assets/contact/splash-top-sm.jpg" />
      </div>

      <div class="contact--headline">
        <div class="contact--headline-text">
          <h2 class="contact--headline-text-item">have any questions about bubly?</h2>
          <h2 class="contact--headline-text-item">give us a shout at <span style="white-space:nowrap;">1-800-433-2652</span> or message us on social!</h2>
          <social class="large-icons"/>
        </div>
      </div>

      <div class="contact--bottom">
      <img src="./../assets/contact/splash-bottom-sm.jpg" />
      </div>

    </section>
    <bubly-footer />
  </div>
</template>

<script>
  import Navigation from '@/components/Navigation';
  import BublyFooter from '@/components/BublyFooter';
  import Social from '@/components/common/Social';

  export default {
    name: 'contact',
    components: {
      Navigation,
      BublyFooter,
      Social
    },
  };
</script>

<style lang='scss' scoped>
  @import './../variables';

  .contact {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0;

    &--headline {
      position: relative;
      flex-grow: 1;
      background-image: url(../assets/contact/splash-bubbles-sm.jpg);
      background-repeat: none;
      background-size: auto 175%;
      background-position: center center;
      padding: 80px 20px;

      &-text {
          margin: 0;
          padding: 0;
          width: 100%;
      }

      &-text-item {
        line-height: 1.3em;
        margin: 15px 0; 
        padding: 0;
      }
    }

    &--top, &--bottom {
      font-size: 0;

      img {
        width: 100%; 
        height: auto;
      }
    }


    /*
     * TABLET
     */

    @include breakpoint('tablet'){
      height: 100vh;

      &--headline {
        flex-grow: 2;
        background-image: url(../assets/contact/splash-bubbles-lg.jpg);
        background-repeat: none;
        background-size: 120% auto;
        background-position: center center;
        padding: 0;

        &-text {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);      
          width: calc(100% - 120px);  
        }

        &-text-item {
          font-size: 32px;
        }

      }

      &--top, &--bottom {
        background-repeat: repeat-x;
        background-position: top center;
        background-size: auto 100%;

        img {
          display: none;
        }
      }

      &--top {
        flex-grow: 1;
        background-image: url(../assets/contact/splash-top-lg.jpg);

      }

      &--bottom {
        flex-grow: 1;
        background-image: url(../assets/contact/splash-bottom-lg.jpg);
      }

    }
  

    /*
     * LAPTOP
     */
     
    @include breakpoint('laptop'){
      height: 100vh;

      &--headline {
        background-size: 100% auto;

        &-text-item {
          font-size: 40px;
        }
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/pages/Contact.vue